import type { Goal } from "instantdb/types";

export const NUTRITION_GOALS: Partial<Goal>[] = [
  {
    id: "eat-more-vegetables",
    title: "Eat more vegetables",
    description: "Incorporate more vegetables into your daily meals",
    symbol: "🥗",
  },
  {
    id: "reduce-processed-foods",
    title: "Reduce processed foods",
    description: "Cut down on processed and packaged foods",
    symbol: "🌱",
  },
  {
    id: "mindful-eating",
    title: "Practice mindful eating",
    description: "Pay attention to hunger cues and eat slowly",
    symbol: "🧘",
  },
];
